/**
 * Created by Languagenut on 28/08/2019.
 */

import React  from 'react';
import {Button, Breadcrumb, Card, Row, Col} from 'react-bootstrap'
import VocabContent from './vocab_content.js';
import contentService from '../../../services/content-service.js';
import ContentStore from '../../../store/content-store.js';
import HomeworkStore from '../../../store/homework-store';
import Translation from '../../../store/internationalization-store';
import Constants from '../../../constants.js';
import SentenceContent from './sentence_content.js';
import VerbContent from './verb_content.js';
import AccountStore from '../../../store/account-store';
import InformationPopup from '../../popup/information_popup.js'
import Checkbox from '../../checkbox.js';

class AssignmentContentSelectTemplate extends React.Component {
    constructor(props) {
        super();
        this.props = props;
        this.currentData = undefined;
        this.state = {
            currentData: this.currentData,
            currentSelected: undefined,
            contentData:[],
            selectedType:"",
            breadcrumbs:[{title:"Vocab Trainer", selectedData:undefined}]
        };


        if(this.props)
        {
            if(this.props.data)
            {
                this.props.data.isMake = true;
                this.props.data.type = this.props.data.types[this.props.data.counter];
            }
        }

    }

    getSelectedValues() {
        var x = this.getSelectedSubValues(this.state.currentData); 
        return x;
    }

    getSelectedSubValues(data) {
        var selectedData = [];
        for (var moduleData in data){
            if (data.hasOwnProperty(moduleData) 
                && data[moduleData].module != undefined) {
                if (data[moduleData].subModules != undefined ) {
                    selectedData = selectedData.concat(this.getSelectedSubValues(data[moduleData].subModules));
                } else if (data[moduleData].module.isChecked == true) {
                    selectedData.push(data[moduleData].module);
                }
            } else if (data.hasOwnProperty(moduleData) 
                    && data[moduleData].uid != undefined) {
                if (data[moduleData].isChecked == true) {
                    selectedData.push(data[moduleData]);
                }
            } else  if (data.hasOwnProperty(moduleData) 
                && data[moduleData].verbUid != undefined) {
                if (data[moduleData].subModules != undefined ) {
                    selectedData = selectedData.concat(this.getSelectedSubValues(data[moduleData].subModules));
                } else if (data[moduleData].isChecked == true) {
                    selectedData.push(data[moduleData]);
                }
            }
        }
        return selectedData;
    }

    selectIntialData(data) {
        if (this.state.breadcrumbs.length == 1) {
            this.exam_initial_uid = data.uid;
        }
        if (data.subModules != undefined) {
            if (this.props.data.type == "exam") {
                this.exam_catalog_uid = data.exam_catalog_uid;
            }
            HomeworkStore.clearTemporaryStore();
            this.state.breadcrumbs.push({title:data.title, selectedData:data.subModules});
            this.setState({currentSelected:data.subModules});
        } else if (data.isLast == false){
            HomeworkStore.clearTemporaryStore();
            this.state.breadcrumbs.push({title:data.title, selectedData:data.subModules});
            this.setState({currentSelected:data.subModules});
        } else {
            //this.state.breadcrumbs.push({title:data.title, selectedData:data.subData});
            var currentTitle = data.title;

            if (this.props.data.type == "custom") {
                var moduleUid = data.uid;
                var catalogUid = data.catalog_uid;

                contentService.getVocabTranslation(data.module_uid, this.props.data.language.ietf).then(function(data) {
                    HomeworkStore.addToTemporaryStore(catalogUid);
                    HomeworkStore.addToTemporaryStore(data.vocabTranslations);
                    HomeworkStore.addToTemporaryStore(currentTitle);
                    HomeworkStore.addToTemporaryStore(moduleUid);
                    this.setState({selectedType:"custom", contentData:data.vocabTranslations});
                }.bind(this));
            }

            if (this.props.data.type.indexOf("vocabs") > -1) {
                var moduleUid = data.uid;
                var catalogUid = data.catalog_uid;

                console.log(data);
                contentService.getVocabTranslation(data.uid, this.props.data.language.ietf).then(function(data) {
                    HomeworkStore.addToTemporaryStore(catalogUid);
                    HomeworkStore.addToTemporaryStore(data.vocabTranslations);
                    HomeworkStore.addToTemporaryStore(currentTitle);
                    HomeworkStore.addToTemporaryStore(moduleUid);
                    this.setState({selectedType:"vocabs", contentData:data.vocabTranslations});
                }.bind(this));
            } else if (this.props.data.type == "sentences") {
                var catalogUid = data.sentence_catalog;
                contentService.getSentenceTranslation(data.sentence_catalog, this.props.data.language.ietf).then(function(data) {
                    HomeworkStore.addToTemporaryStore(catalogUid);
                    HomeworkStore.addToTemporaryStore(data.sentenceTranslations);
                    HomeworkStore.addToTemporaryStore(currentTitle);
                    this.setState({selectedType:"sentences", contentData:data.sentenceTranslations});
                }.bind(this));
            } else if (this.props.data.type == "grammar") {
                var catalogUid = data.grammar_catalog_uid;
                contentService.getSentenceTranslation(data.grammar_catalog_uid, this.props.data.language.ietf).then(function(data) {
                    HomeworkStore.addToTemporaryStore(catalogUid);
                    HomeworkStore.addToTemporaryStore(data.sentenceTranslations);
                    HomeworkStore.addToTemporaryStore(currentTitle);
                    this.setState({selectedType:"grammar", contentData:data.sentenceTranslations});
                }.bind(this));
            } else if (this.props.data.type == "verbs") {
                var moduleUid = data.uid;
                contentService.getVerbTranslation(data.verbUid, this.props.data.language.ietf).then(function(data2) {
                    HomeworkStore.addToTemporaryStore(data.verbUid);
                    HomeworkStore.addToTemporaryStore(data2.verbTranslations);
                    HomeworkStore.addToTemporaryStore(currentTitle);
                    this.setState({selectedType:"verbs", contentData:data2.verbTranslations});
                }.bind(this));
            } else if (this.props.data.type == "exam") {
                var moduleUid = data.uid;
                contentService.getExamTranslation(data.uid).then(function(data2) {
                    HomeworkStore.addToTemporaryStore(data.uid);
                    HomeworkStore.addToTemporaryStore(data2);
                    HomeworkStore.addToTemporaryStore(data.difficulty);
                    HomeworkStore.addToTemporaryStore(this.state.breadcrumbs[this.state.breadcrumbs.length-2].title);
                    HomeworkStore.addToTemporaryStore(this.exam_catalog_uid);
                    this.props.forceAdvance();
                }.bind(this));
            }
        }
    }

    componentWillMount() {
        ContentStore.on(Constants.GET_ALL_MODULE_IDS,  function() {
            if (this.props.data.type.indexOf("vocabs") > -1) {
                if (this.props.data.type.indexOf("vocabs-") > -1) {
                    this.setState({
                        breadcrumbs:[{title:this.props.data.type.split("-")[2], selectedData:undefined}],
                        "currentData":ContentStore.vocabModules,
                    });
                } else {
                    var newBreadCrumbs = [{title:Translation.get(12233, "Vocabulary"), selectedData:undefined}];
                    if ([9201, 9202, 9203, 20634,20669,20704].indexOf(parseInt(AccountStore.curriculumData.startScreen)) > -1) {
                        newBreadCrumbs = [{title:"Cambridge IGCSE", selectedData:undefined}]
                    } else if ([13300,13301,13302].indexOf(parseInt(AccountStore.curriculumData.startScreen)) > -1) {
                        newBreadCrumbs =  [{title:"Edexcel-International GCSE Vocabulary", selectedData:undefined}]
                    }
                    this.setState({
                        breadcrumbs:newBreadCrumbs,
                        "currentData":ContentStore.vocabModules,
                    });
                }
            } else if (this.props.data.type == "exam") {
                this.setState({
                    breadcrumbs:[{title:Translation.get(12042, "Exam Skills"), selectedData:undefined}],
                    "currentData":ContentStore.vocabModules,
                });
            }
        }.bind(this))


        ContentStore.on(Constants.CUSTOM_MODULES,  ()=>{
            this.setState({
                breadcrumbs:[{title:Translation.get(649, "My Content"), selectedData:undefined}],
                currentData:ContentStore.customModules,
            });
        })

        ContentStore.on(Constants.GET_ALL_SENTENCEBUILDING_IDS,  ()=>{
            var modules = ContentStore.sentenceModules
            this.setState({
                breadcrumbs:[{title:Translation.get(89, "Sentence Building"), selectedData:undefined}],
                "currentData":modules,
            });
        });

        ContentStore.on(Constants.GET_ALL_GRAMMAR_IDS,  ()=>{
            var modules = ContentStore.grammarModules
            this.setState({
                breadcrumbs:[{title:Translation.get(100, "Grammar"), selectedData:undefined}],
                "currentData":modules,
            });
        });

        ContentStore.on(Constants.GET_ALL_VERB_IDS,  ()=>{
            var modules = ContentStore.verbModules
            this.setState({
                breadcrumbs:[{title:Translation.get(1026,"Verbs"), selectedData:undefined}],
                "currentData":modules,
            });
        });
    }

    componentDidMount() {

        if (this.props.data.type == "vocabs") {
            contentService.getAllVocabUids(AccountStore.curriculumData.startScreen);
        } else if (this.props.data.type.indexOf("vocabs-") > -1) {
            contentService.getAllVocabUids(this.props.data.type.split("-")[1]);
        }
        else if (this.props.data.type == "custom") {
            contentService.getCustomModules(this.props.data.language.ietf);;

            /*contentService.getTeacherScreen(this.props.data.language.ietf).then(function(screen){
                contentService.getAllVocabUids(screen);
                //contentService.getCustomVocabulary(screen , this.props.data.language.ietf , AccountStore.curriculumData.packageUid);
            }.bind(this))*/
        }
        else if (this.props.data.type == "sentences") {
            contentService.getAllSentenceUids(AccountStore.curriculumData.sentenceScreen, AccountStore.curriculumData.packageUid, this.props.data.language.ietf);
        } else if (this.props.data.type == "grammar") {
            contentService.getAllGrammarUids(AccountStore.curriculumData.grammarScreen, AccountStore.curriculumData.packageUid, this.props.data.language.ietf);
        } else if (this.props.data.type == "verbs") {
            contentService.getAllVerbUids(AccountStore.curriculumData.uid, this.props.data.language.ietf);
        } else if (this.props.data.type == "exam") {
            contentService.getAllVocabUids(AccountStore.curriculumData.examScreen);
        }
        HomeworkStore.clearTemporaryStore();
    }

    menuItem(data){
        var examStuff = this.exam_initial_uid;
        var allowCheck = true;
        var clickCheckbox = function() {
            if (!allowCheck) {
                allowCheck = true;
                return;
            }
            if (this.props.data.type == "grammar") {
                contentService.getSentenceTranslation(data.grammar_catalog_uid, this.props.data.language.ietf).then(function(data2) {
                    data.other = data2.sentenceTranslations[0].other;
                }.bind(this));
            } else if (this.props.data.type == "exam" && data.isChecked != true) {
                var selectedValues = this.getSelectedValues();
                for (var i = 0; i < selectedValues.length; i++){
                    selectedValues[i].isChecked = false;
                }
            }
            
            data.isChecked = !data.isChecked;
            data.exam_catalog_uid = this.exam_catalog_uid; 
            this.setState({update:true});
        }.bind(this);

        var selectData = function() {
            if (data.originalTitleExam != undefined) {
                contentService.getExamProper(examStuff, data.originalTitleExam).then(
                    function(response) {
                        this.setState({information:true, informationText:response.translation.translation_uid})
                    }.bind(this))
            } else {
                this.selectIntialData(data)
            }
        }.bind(this);

        if (data.title == "Speak First") {
            data.title = "Speak First - Please do not assign Reading or Writing Skills in this area";
        }

        if (data.subModules == undefined || data.isLast) {
            return <Col md={6} onClick={clickCheckbox}>  <Card body><Row>
                    <Col sm={{span: 11, offset: 0}}>
                            <span className="float-left"><i onClick={function() {
                                allowCheck = false;
                                selectData();
                            }}  className={(data.subModules == undefined || data.isLast) ? "hyperlink hyperlink_black fas fa-info-circle" : ""}></i>&nbsp;{data.title}</span>
                            <div onClick={function() {
                                allowCheck = false;
                                selectData();
                            }} className="float-left" style={{paddingLeft:"10px"}}></div>
                            </Col>
                    <Col sm={{span: 1, offset: 0}}><span className="float-right">
                            <Checkbox isDisabled checked={data.isChecked}/></span>
                    </Col>
                </Row></Card> <br/></Col>
        } else {
            return <Col md={6} >  <Card body><Row onClick={function() {this.selectIntialData(data)}.bind(this)}>
                    <Col sm={{span: 11, offset: 0}}><span className="float-left">{data.title}</span></Col>
                    <Col sm={{span: 1, offset: 0}}><span className="float-right"> <i className={(data.subModules == undefined || data.isLast) ? "" : "fas fa-chevron-right"}></i></span></Col>
                </Row></Card> <br/></Col>
        }
    }

    viewVocab(){
        let body = [];
        if (this.state.currentSelected == undefined) {
            for (var moduleData in this.state.currentData){
                if (this.state.currentData.hasOwnProperty(moduleData) 
                && this.state.currentData[moduleData].module != undefined) {
                    var module = this.state.currentData[moduleData];
                    module.module.title = 
                        Translation.getModuleNoIndexTranslation(module.module.title , module.module.title);
                        module.module.subModules = module.subModules;
                        body.push(this.menuItem(module.module));
                }
            }
        } else {
            for (var moduleData in this.state.currentSelected){
                if (this.state.currentSelected.hasOwnProperty(moduleData) 
                && this.state.currentSelected[moduleData].module != undefined) {
                    var module = this.state.currentSelected[moduleData];
                    module.module.title = 
                        Translation.getModuleNoIndexTranslation(module.module.title , module.module.title);
                    module.module.subModules = module.subModules;
                    body.push(this.menuItem(module.module));
                }
            }
        }
        return body;
    }


    viewCustom(){
        let body = [];
        if (this.state.currentSelected == undefined) {
            for (var moduleData in this.state.currentData){
                if (this.state.currentData.hasOwnProperty(moduleData)
                    && this.state.currentData[moduleData].module != undefined) {
                    var module = this.state.currentData[moduleData];
                    module.module.title =
                        Translation.getModuleNoIndexTranslation(module.module.title , module.module.title);
                    module.module.subModules = module.subModules;
                    body.push(this.menuItem(module.module));
                }
            }
        } else {
            for (var moduleData in this.state.currentSelected){
                if (this.state.currentSelected.hasOwnProperty(moduleData)
                    && this.state.currentSelected[moduleData].module != undefined) {
                    var module = this.state.currentSelected[moduleData];
                    module.module.title =
                        Translation.getModuleNoIndexTranslation(module.module.title , module.module.title);
                    module.module.subModules = module.subModules;
                    body.push(this.menuItem(module.module));
                }
            }
        }
        return body;
    }

    viewExam(){
        let body = [];
        if (this.state.currentSelected == undefined) {
            for (var moduleData in this.state.currentData){
                if (this.state.currentData.hasOwnProperty(moduleData) 
                && this.state.currentData[moduleData].module != undefined) {
                    var module = this.state.currentData[moduleData];
                        if (module.subModules != undefined) {
                            module.module.title = 
                                Translation.getModuleNoIndexTranslation(module.module.title);
                        } else {
                            if (module.module.originalTitleExam == undefined) {
                                module.module.originalTitleExam = module.module.title;
                            }
                            module.module.title = Translation.get(12721, "Exam Skills - Challenge Level ") + module.module.originalTitleExam;
                        }
                        module.module.subModules = module.subModules;
                        body.push(this.menuItem(module.module));
                }
            }
        } else {
            for (var moduleData in this.state.currentSelected){
                if (this.state.currentSelected.hasOwnProperty(moduleData) 
                && this.state.currentSelected[moduleData].module != undefined) {
                    var module = this.state.currentSelected[moduleData];
                    if (module.subModules != undefined) {
                        module.module.title = 
                            Translation.getModuleNoIndexTranslation(module.module.title);
                    } else {
                        
                        if (module.module.originalTitleExam == undefined) {
                            module.module.originalTitleExam = module.module.title;
                        }
                        module.module.difficulty = module.module.originalTitleExam;
                        module.module.title = Translation.get(12721, "Exam Skills - Challenge Level ") + module.module.originalTitleExam;
                    }
                    module.module.subModules = module.subModules;
                    body.push(this.menuItem(module.module));
                }
            }
        }
        return body;
    }

    viewSentence(){
        let body = [];
        if (this.state.currentSelected == undefined) {
            for (var i = 0; i < this.state.currentData.length; i++){
                var module = this.state.currentData[i];
                module.title = 
                    Translation.getModuleNoIndexTranslation(module.title);
                body.push(this.menuItem(module));
            }
        } else {
            for (var i = 0; i < this.state.currentSelected.length; i++){
                var module = this.state.currentSelected[i];
                module.title = 
                    Translation.getModuleNoIndexTranslation(module.title);
                body.push(this.menuItem(module));
            }
        }
        return body;
    }

    viewVerb(){
        let body = [];
        if (this.state.currentSelected == undefined) {
            for (var i = 0; i < this.state.currentData.length; i++){
                var module = this.state.currentData[i];
                body.push(this.menuItem(module));
            }
        } else {
            for (var i = 0; i < this.state.currentSelected.length; i++){
                var module = this.state.currentSelected[i];
                body.push(this.menuItem(module));
            }
        }
        return body;
    }

    buildBreadCrumbs() {
        var breadCrumbs = [];

        for (var i = 0; i < this.state.breadcrumbs.length; i++) {
            breadCrumbs.push(this.getBreadCrumb(this.state.breadcrumbs[i], i , i == this.state.breadcrumbs.length - 1));
        }
        return breadCrumbs;
    }

    getBreadCrumb(currentData, i , active) {



        return <Breadcrumb.Item bsPrefix="breadcrumb-item breadcrumb2 floatLeft" active={active} onClick={!active ?function(){
            var newbreadCrumbs = this.state.breadcrumbs.splice(0,i+1);
            this.setState({
                currentSelected:currentData.selectedData,
                breadcrumbs:newbreadCrumbs,
                selectedType:""})
        }.bind(this) : function(){}}>{currentData.title}</Breadcrumb.Item>
    }

    renderTime(time){

        function secondsToHms(d) {
            d = Number(d);
            if (d ==0) {
                return "-"
            }
            var h = Math.floor(d / 3600);
            var m = Math.floor(d % 3600 / 60);
            var s = Math.floor(d % 3600 % 60);

            if (h < 9) {
                h = "0"+h;
            }
            if (m < 9) {
                m = "0"+m;
            }
            if (s < 9) {
                s = "0"+s;
            }


            var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
            var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes") : "";
            var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";

            return hDisplay+ mDisplay;
        }

        return secondsToHms(time);
    }

    render(){

        console.log(this.state.currentData )
        if (this.state.currentData == undefined) {
            return "";
        }
        var currentPage = "";
        var popoutPage = "";
        var showPopout = true;


        if (this.props.data.type.indexOf("vocabs") > -1  || this.props.data.type == "custom") {
            currentPage = this.viewVocab.bind(this)();
        } else if (this.props.data.type == "sentences") {
            currentPage = this.viewSentence.bind(this)();
        } else if (this.props.data.type == "grammar") {
            currentPage = this.viewSentence.bind(this)();
        } else if (this.props.data.type == "verbs") {
            currentPage = this.viewVerb.bind(this)();
        } else if (this.props.data.type == "exam") {
            currentPage = this.viewExam.bind(this)();
        }

        if (this.state.selectedType == "") {
            showPopout = false;
        } else if (this.props.data.type.indexOf("vocabs") > -1 || this.state.selectedType == "custom") {
            console.log(this.state.contentData)
            popoutPage = <VocabContent vocabTranslations={this.state.contentData}></VocabContent>
        } else if (this.state.selectedType == "sentences") {
            popoutPage = <SentenceContent sentenceTranslations={this.state.contentData}></SentenceContent>
        } else if (this.state.selectedType == "grammar") {
            popoutPage = <SentenceContent sentenceTranslations={this.state.contentData}></SentenceContent>
        } else if (this.state.selectedType == "verbs") {
            popoutPage = <VerbContent verbTranslations={this.state.contentData}></VerbContent>
        } else if (this.state.selectedType == "exam") {
            //popoutPage = <ExamContent verbTranslations={this.state.contentData}></VerbContent>
        }

        var newOnClick = function() {
            var selectedData = this.getSelectedValues();
            HomeworkStore.setSelectedMassData(selectedData);
            this.props.forceAdvance();
        }.bind(this);

        var AdvanceButton = React.createElement(Button, {
            onClick: newOnClick,
            bsStyle:'primary',
            className:"btn-block",
            disabled:this.getSelectedValues().length < 1
        },Translation.get(631 ,'Next'));

        return <div>
            <InformationPopup title={Translation.get(12291 , 'Preview')} show={showPopout} onHide={()=>{
                    this.setState({selectedType:""})
                }}>
                {popoutPage}
            </InformationPopup>
            <InformationPopup title={Translation.get(12722 , 'Learning outcomes')} show={this.state.information} onHide={()=>{this.setState({information:false})}}>
                {Translation.get(this.state.informationText , 'learningOutcome here')}
            </InformationPopup>
            <Row>
                <Col md={12}>
                    <Card body>
                        <Breadcrumb bsPrefix="breadcrumb breadcrumb2">
                            <div style={{width:"100%"}}>
                                <div style={{float:"left"}}>
                                    {this.buildBreadCrumbs()}
                                </div>
                                <div style={{float:"right", color:"#FFFFFF", fontWeight:"bold"}}>
                                    {Translation.get(12790, 'Estimated assignment time:')}: {this.renderTime(HomeworkStore.getCurrentTime())}</div>
                            </div>
                        </Breadcrumb>
                    <Row>
                        {currentPage}
                    </Row>
                    </Card>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col sm={6}></Col>
                <Col sm={6}>{AdvanceButton}</Col>
            </Row>
        </div>;


    }


}


export default {
    name: function() {return Translation.get(851,"Content")},
    icon:<i class="fa-2x fas fa-upload"></i>,
    title:null,
    disableButtons:true,
    onSubmit: function (done){
        done();
    },
    onBack:function(done){
        done();
    },
    component: AssignmentContentSelectTemplate
}